/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 0732e33f98334978ea23ccd16f58e1be590ae29aa6018603d6804968c7f35aa6 */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getConfigurationsByClientId: build.query<
      GetConfigurationsByClientIdApiResponse,
      GetConfigurationsByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/Configurations/${queryArg.clientId ?? ':clientId'}`,
        headers: {},
      }),
    }),
    postConfigurationsByClientId: build.mutation<
      PostConfigurationsByClientIdApiResponse,
      PostConfigurationsByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/Configurations/${queryArg.clientId ?? ':clientId'}`,
        method: 'POST',
        body: queryArg.externalInboxAuthModel,
        headers: {},
      }),
    }),
    deleteConfigurationsByClientId: build.mutation<
      DeleteConfigurationsByClientIdApiResponse,
      DeleteConfigurationsByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/Configurations/${queryArg.clientId ?? ':clientId'}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    postConfigurationsGmailByClientId: build.mutation<
      PostConfigurationsGmailByClientIdApiResponse,
      PostConfigurationsGmailByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/Configurations/gmail/${queryArg.clientId ?? ':clientId'}`,
        method: 'POST',
        body: queryArg.gmailSmtpConfigModel,
        headers: {},
      }),
    }),
    postConfigurationsByClientIdConfirmation: build.mutation<
      PostConfigurationsByClientIdConfirmationApiResponse,
      PostConfigurationsByClientIdConfirmationApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/Configurations/${queryArg.clientId ?? ':clientId'}/confirmation`,
        method: 'POST',
        body: queryArg.externalInboxConfigurationModel,
        headers: {},
      }),
    }),
    postConfigurationsByClientIdSync: build.mutation<
      PostConfigurationsByClientIdSyncApiResponse,
      PostConfigurationsByClientIdSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/Configurations/${queryArg.clientId ?? ':clientId'}/sync`,
        method: 'POST',
        body: queryArg.synchronizeInboxModel,
        headers: {},
      }),
    }),
    getEmailMessagesByMessageIdAttachmentsAndAttachmentId: build.query<
      GetEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiResponse,
      GetEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/attachments/${queryArg.attachmentId}`,
        headers: {},
      }),
    }),
    deleteEmailMessagesByMessageIdAttachmentsAndAttachmentId: build.mutation<
      DeleteEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiResponse,
      DeleteEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/attachments/${queryArg.attachmentId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    postEmailMessagesByMessageIdAttachments: build.mutation<
      PostEmailMessagesByMessageIdAttachmentsApiResponse,
      PostEmailMessagesByMessageIdAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/attachments`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
    postEmailMessagesList: build.query<
      PostEmailMessagesListApiResponse,
      PostEmailMessagesListApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/query`,
        method: 'POST',
        body: queryArg.emailMessageQueryModel,
        headers: {},
      }),
    }),
    getEmailMessagesStatistics: build.query<
      GetEmailMessagesStatisticsApiResponse,
      GetEmailMessagesStatisticsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/clients/${queryArg.clientId ?? ':clientId'}/statistics`,
        headers: {},
      }),
    }),
    getEmailMessagesByMessageId: build.query<
      GetEmailMessagesByMessageIdApiResponse,
      GetEmailMessagesByMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}`,
        headers: {},
      }),
    }),
    patchEmailMessagesByMessageId: build.mutation<
      PatchEmailMessagesByMessageIdApiResponse,
      PatchEmailMessagesByMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}`,
        method: 'PATCH',
        body: queryArg.body,
        headers: {},
      }),
    }),
    deleteEmailMessagesByMessageId: build.mutation<
      DeleteEmailMessagesByMessageIdApiResponse,
      DeleteEmailMessagesByMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    putEmailMessagesByMessageIdLabels: build.mutation<
      PutEmailMessagesByMessageIdLabelsApiResponse,
      PutEmailMessagesByMessageIdLabelsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/Labels`,
        method: 'PUT',
        body: queryArg.labelIdsModel,
        headers: {},
      }),
    }),
    getEmailMessagesByMessageIdLabels: build.query<
      GetEmailMessagesByMessageIdLabelsApiResponse,
      GetEmailMessagesByMessageIdLabelsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/Labels`,
        headers: {},
      }),
    }),
    patchEmailMessages: build.mutation<
      PatchEmailMessagesApiResponse,
      PatchEmailMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages`,
        method: 'PATCH',
        body: queryArg.messagesPatchModel,
        headers: {},
      }),
    }),
    postEmailMessages: build.mutation<
      PostEmailMessagesApiResponse,
      PostEmailMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages`,
        method: 'POST',
        body: queryArg.newEmailMessageRequestModel,
        headers: {},
      }),
    }),
    deleteEmailMessages: build.mutation<
      DeleteEmailMessagesApiResponse,
      DeleteEmailMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages`,
        method: 'DELETE',
        body: queryArg.deleteMessagesRequestModel,
        headers: {},
      }),
    }),
    postEmailMessagesByMessageIdReply: build.mutation<
      PostEmailMessagesByMessageIdReplyApiResponse,
      PostEmailMessagesByMessageIdReplyApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/reply`,
        method: 'POST',
        body: queryArg.emailMessageReplyRequestModel,
        headers: {},
      }),
    }),
    postEmailMessagesByMessageIdForward: build.mutation<
      PostEmailMessagesByMessageIdForwardApiResponse,
      PostEmailMessagesByMessageIdForwardApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/forward`,
        method: 'POST',
        headers: {},
      }),
    }),
    postEmailMessagesByMessageIdSend: build.mutation<
      PostEmailMessagesByMessageIdSendApiResponse,
      PostEmailMessagesByMessageIdSendApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/send`,
        method: 'POST',
        headers: {},
      }),
    }),
    postEmailMessagesByMessageIdSendDirect: build.mutation<
      PostEmailMessagesByMessageIdSendDirectApiResponse,
      PostEmailMessagesByMessageIdSendDirectApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/send-direct`,
        method: 'POST',
        headers: {},
      }),
    }),
    getEmailMessagesByMessageIdRecipients: build.query<
      GetEmailMessagesByMessageIdRecipientsApiResponse,
      GetEmailMessagesByMessageIdRecipientsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/recipients`,
        headers: {},
      }),
    }),
    patchEmailMessagesByMessageIdRecipients: build.mutation<
      PatchEmailMessagesByMessageIdRecipientsApiResponse,
      PatchEmailMessagesByMessageIdRecipientsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/recipients`,
        method: 'PATCH',
        body: queryArg.body,
        headers: {},
      }),
    }),
    getEmailMessagesByMessageIdReceipt: build.query<
      GetEmailMessagesByMessageIdReceiptApiResponse,
      GetEmailMessagesByMessageIdReceiptApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/receipt`,
        headers: {},
      }),
    }),
    putEmailMessagesByMessageIdIsread: build.mutation<
      PutEmailMessagesByMessageIdIsreadApiResponse,
      PutEmailMessagesByMessageIdIsreadApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/isread`,
        method: 'PUT',
        headers: {},
      }),
    }),
    getEmailMessagesByMessageIdReadstatusSummary: build.query<
      GetEmailMessagesByMessageIdReadstatusSummaryApiResponse,
      GetEmailMessagesByMessageIdReadstatusSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/readstatus/summary`,
        headers: {},
      }),
    }),
    getEmailMessagesByMessageIdReadstatus: build.query<
      GetEmailMessagesByMessageIdReadstatusApiResponse,
      GetEmailMessagesByMessageIdReadstatusApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/messages/${queryArg.messageId}/readstatus`,
        headers: {},
      }),
    }),
    getLabels: build.query<GetLabelsApiResponse, GetLabelsApiArg>({
      query: (queryArg) => ({
        url: `/inbox2/clients/${queryArg.clientId ?? ':clientId'}/labels`,
        headers: {},
      }),
    }),
    postEmailByClientIdJunkList: build.query<
      PostEmailByClientIdJunkListApiResponse,
      PostEmailByClientIdJunkListApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/${queryArg.clientId ?? ':clientId'}/junk/query`,
        method: 'POST',
        body: queryArg.junkEmailQueryModel,
        headers: {},
      }),
    }),
    getEmailByClientIdJunkAndMessageId: build.query<
      GetEmailByClientIdJunkAndMessageIdApiResponse,
      GetEmailByClientIdJunkAndMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/${queryArg.clientId ?? ':clientId'}/junk/${queryArg.messageId}`,
        headers: {},
      }),
    }),
    putEmailByClientIdJunk: build.mutation<
      PutEmailByClientIdJunkApiResponse,
      PutEmailByClientIdJunkApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/${queryArg.clientId ?? ':clientId'}/junk`,
        method: 'PUT',
        body: queryArg.moveJunkModel,
        headers: {},
      }),
    }),
    getClientByClientIdAvailablecases: build.query<
      GetClientByClientIdAvailablecasesApiResponse,
      GetClientByClientIdAvailablecasesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/client/${queryArg.clientId ?? ':clientId'}/availablecases`,
        headers: {},
      }),
    }),
    putCasesByCaseIdMessages: build.mutation<
      PutCasesByCaseIdMessagesApiResponse,
      PutCasesByCaseIdMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/cases/${queryArg.caseId}/messages`,
        method: 'PUT',
        body: queryArg.putCaseConnectionModel,
        headers: {},
      }),
    }),
    getFrequentrecipients: build.query<
      GetFrequentrecipientsApiResponse,
      GetFrequentrecipientsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/clients/${queryArg.clientId ?? ':clientId'}/frequentrecipients`,
        headers: {},
        params: {
          type: queryArg['type'],
        },
      }),
    }),
    getConfigurationsByClientIdSignature: build.query<
      GetConfigurationsByClientIdSignatureApiResponse,
      GetConfigurationsByClientIdSignatureApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/configurations/${queryArg.clientId ?? ':clientId'}/signature`,
        headers: {},
      }),
    }),
    putConfigurationsByClientIdSignature: build.mutation<
      PutConfigurationsByClientIdSignatureApiResponse,
      PutConfigurationsByClientIdSignatureApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/configurations/${queryArg.clientId ?? ':clientId'}/signature`,
        method: 'PUT',
        body: queryArg.signatureUpsertModel,
        headers: {},
      }),
    }),
    postSmsMessagesList: build.query<
      PostSmsMessagesListApiResponse,
      PostSmsMessagesListApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/query`,
        method: 'POST',
        body: queryArg.smsMessageQueryModel,
        headers: {},
      }),
    }),
    getSmsMessagesByMessageId: build.query<
      GetSmsMessagesByMessageIdApiResponse,
      GetSmsMessagesByMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}`,
        headers: {},
      }),
    }),
    patchSmsMessagesByMessageId: build.mutation<
      PatchSmsMessagesByMessageIdApiResponse,
      PatchSmsMessagesByMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}`,
        method: 'PATCH',
        body: queryArg.body,
        headers: {},
      }),
    }),
    deleteSmsMessagesByMessageId: build.mutation<
      DeleteSmsMessagesByMessageIdApiResponse,
      DeleteSmsMessagesByMessageIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    putSmsMessagesByMessageIdLabels: build.mutation<
      PutSmsMessagesByMessageIdLabelsApiResponse,
      PutSmsMessagesByMessageIdLabelsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}/Labels`,
        method: 'PUT',
        body: queryArg.labelIdsModel,
        headers: {},
      }),
    }),
    patchSmsMessages: build.mutation<
      PatchSmsMessagesApiResponse,
      PatchSmsMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages`,
        method: 'PATCH',
        body: queryArg.messagesPatchModel,
        headers: {},
      }),
    }),
    postSmsMessages: build.mutation<
      PostSmsMessagesApiResponse,
      PostSmsMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages`,
        method: 'POST',
        body: queryArg.newSmsMessageRequestModel,
        headers: {},
      }),
    }),
    deleteSmsMessages: build.mutation<
      DeleteSmsMessagesApiResponse,
      DeleteSmsMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages`,
        method: 'DELETE',
        body: queryArg.deleteMessagesRequestModel,
        headers: {},
      }),
    }),
    postSmsMessagesByMessageIdSend: build.mutation<
      PostSmsMessagesByMessageIdSendApiResponse,
      PostSmsMessagesByMessageIdSendApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}/send`,
        method: 'POST',
        headers: {},
      }),
    }),
    getSmsMessagesByMessageIdRecipients: build.query<
      GetSmsMessagesByMessageIdRecipientsApiResponse,
      GetSmsMessagesByMessageIdRecipientsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}/recipients`,
        headers: {},
      }),
    }),
    patchSmsMessagesByMessageIdRecipients: build.mutation<
      PatchSmsMessagesByMessageIdRecipientsApiResponse,
      PatchSmsMessagesByMessageIdRecipientsApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}/recipients`,
        method: 'PATCH',
        body: queryArg.body,
        headers: {},
      }),
    }),
    getSmsMessagesByMessageIdReceipt: build.query<
      GetSmsMessagesByMessageIdReceiptApiResponse,
      GetSmsMessagesByMessageIdReceiptApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/messages/${queryArg.messageId}/receipt`,
        headers: {},
      }),
    }),
    getSmsSettingsByClientId: build.query<
      GetSmsSettingsByClientIdApiResponse,
      GetSmsSettingsByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/settings/${queryArg.clientId ?? ':clientId'}`,
        headers: {},
      }),
    }),
    getSmsStatusByClientId: build.query<
      GetSmsStatusByClientIdApiResponse,
      GetSmsStatusByClientIdApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/sms/status/${queryArg.clientId ?? ':clientId'}`,
        headers: {},
      }),
    }),
    getEmailByClientIdJunkCount: build.query<
      GetEmailByClientIdJunkCountApiResponse,
      GetEmailByClientIdJunkCountApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/email/${queryArg.clientId ?? ':clientId'}/junk/count`,
        headers: {},
      }),
    }),
    getConfigurationsByClientIdAutoreply: build.query<
      GetConfigurationsByClientIdAutoreplyApiResponse,
      GetConfigurationsByClientIdAutoreplyApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/configurations/${queryArg.clientId ?? ':clientId'}/autoreply`,
        headers: {},
      }),
    }),
    putConfigurationsByClientIdAutoreply: build.mutation<
      PutConfigurationsByClientIdAutoreplyApiResponse,
      PutConfigurationsByClientIdAutoreplyApiArg
    >({
      query: (queryArg) => ({
        url: `/inbox2/configurations/${queryArg.clientId ?? ':clientId'}/autoreply`,
        method: 'PUT',
        body: queryArg.autoReplyUpdateModel,
        headers: {},
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as inbox2 }
export type GetConfigurationsByClientIdApiResponse =
  /** status 200 OK */ InboxConfigurationModelRead
export type GetConfigurationsByClientIdApiArg = {
  clientId?: string
}
export type PostConfigurationsByClientIdApiResponse =
  /** status 200 OK */ string
export type PostConfigurationsByClientIdApiArg = {
  /** Client client to initiate configuration for */
  clientId?: string
  /** Configuration options */
  externalInboxAuthModel: ExternalInboxAuthModel
}
export type DeleteConfigurationsByClientIdApiResponse =
  /** status 200 OK */ string
export type DeleteConfigurationsByClientIdApiArg = {
  clientId?: string
}
export type PostConfigurationsGmailByClientIdApiResponse =
  /** status 200 OK */ string
export type PostConfigurationsGmailByClientIdApiArg = {
  clientId?: string
  gmailSmtpConfigModel: GmailSmtpConfigModel
}
export type PostConfigurationsByClientIdConfirmationApiResponse =
  /** status 200 OK */ string
export type PostConfigurationsByClientIdConfirmationApiArg = {
  clientId?: string
  externalInboxConfigurationModel: ExternalInboxConfigurationModel
}
export type PostConfigurationsByClientIdSyncApiResponse =
  /** status 200 OK */ string
export type PostConfigurationsByClientIdSyncApiArg = {
  /** client id */
  clientId?: string
  /** Model containing sync date */
  synchronizeInboxModel: SynchronizeInboxModel
}
export type GetEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiResponse =
  unknown
export type GetEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiArg = {
  /** Inbox messag id */
  messageId: string
  /** Attachment id */
  attachmentId: string
}
export type DeleteEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiResponse =
  unknown
export type DeleteEmailMessagesByMessageIdAttachmentsAndAttachmentIdApiArg = {
  messageId: string
  attachmentId: string
}
export type PostEmailMessagesByMessageIdAttachmentsApiResponse = unknown
export type PostEmailMessagesByMessageIdAttachmentsApiArg = {
  /** The email message to add attachments to */
  messageId: string
  body: {
    /** Any files being uploaded */
    files?: any
    /** Any files to retrieve from the board's document archive */
    archiveDocumentIds?: any
  }
}
export type PostEmailMessagesListApiResponse =
  /** status 200 OK */ EmailMessageQueryResultRead
export type PostEmailMessagesListApiArg = {
  /** Query info */
  emailMessageQueryModel: EmailMessageQueryModel
}
export type GetEmailMessagesStatisticsApiResponse =
  /** status 200 OK */ EmailStatisticsModel
export type GetEmailMessagesStatisticsApiArg = {
  clientId?: string
}
export type GetEmailMessagesByMessageIdApiResponse =
  /** status 200 OK */ EmailModelRead
export type GetEmailMessagesByMessageIdApiArg = {
  messageId: string
}
export type PatchEmailMessagesByMessageIdApiResponse = unknown
export type PatchEmailMessagesByMessageIdApiArg = {
  /** Email inbox message id */
  messageId: string
  /** Patch model */
  body: Operation[]
}
export type DeleteEmailMessagesByMessageIdApiResponse = unknown
export type DeleteEmailMessagesByMessageIdApiArg = {
  /** Message id */
  messageId: string
}
export type PutEmailMessagesByMessageIdLabelsApiResponse = unknown
export type PutEmailMessagesByMessageIdLabelsApiArg = {
  messageId: string
  labelIdsModel: LabelIdsModel
}
export type GetEmailMessagesByMessageIdLabelsApiResponse =
  /** status 200 OK */ LabelModel[]
export type GetEmailMessagesByMessageIdLabelsApiArg = {
  messageId: string
}
export type PatchEmailMessagesApiResponse =
  /** status 200 OK */ PatchMessagesResponseModel
export type PatchEmailMessagesApiArg = {
  /** Patch model */
  messagesPatchModel: MessagesPatchModel
}
export type PostEmailMessagesApiResponse = /** status 200 OK */ string
export type PostEmailMessagesApiArg = {
  newEmailMessageRequestModel: NewEmailMessageRequestModel
}
export type DeleteEmailMessagesApiResponse =
  /** status 200 OK */ DeleteMessagesResponseModel
export type DeleteEmailMessagesApiArg = {
  deleteMessagesRequestModel: DeleteMessagesRequestModel
}
export type PostEmailMessagesByMessageIdReplyApiResponse =
  /** status 200 OK */ string
export type PostEmailMessagesByMessageIdReplyApiArg = {
  messageId: string
  emailMessageReplyRequestModel: EmailMessageReplyRequestModel
}
export type PostEmailMessagesByMessageIdForwardApiResponse =
  /** status 200 OK */ string
export type PostEmailMessagesByMessageIdForwardApiArg = {
  messageId: string
}
export type PostEmailMessagesByMessageIdSendApiResponse =
  /** status 200 OK */ string
export type PostEmailMessagesByMessageIdSendApiArg = {
  messageId: string
}
export type PostEmailMessagesByMessageIdSendDirectApiResponse =
  /** status 200 OK */ string
export type PostEmailMessagesByMessageIdSendDirectApiArg = {
  messageId: string
}
export type GetEmailMessagesByMessageIdRecipientsApiResponse =
  /** status 200 OK */ RecipientModelRead[]
export type GetEmailMessagesByMessageIdRecipientsApiArg = {
  messageId: string
}
export type PatchEmailMessagesByMessageIdRecipientsApiResponse = unknown
export type PatchEmailMessagesByMessageIdRecipientsApiArg = {
  messageId: string
  body: Operation[]
}
export type GetEmailMessagesByMessageIdReceiptApiResponse = unknown
export type GetEmailMessagesByMessageIdReceiptApiArg = {
  messageId: string
}
export type PutEmailMessagesByMessageIdIsreadApiResponse =
  /** status 200 OK */ string
export type PutEmailMessagesByMessageIdIsreadApiArg = {
  messageId: string
}
export type GetEmailMessagesByMessageIdReadstatusSummaryApiResponse =
  /** status 200 OK */ ReadStatusSummary
export type GetEmailMessagesByMessageIdReadstatusSummaryApiArg = {
  messageId: string
}
export type GetEmailMessagesByMessageIdReadstatusApiResponse =
  /** status 200 OK */ ReadStatusDetails
export type GetEmailMessagesByMessageIdReadstatusApiArg = {
  messageId: string
}
export type GetLabelsApiResponse = /** status 200 OK */ LabelsModel
export type GetLabelsApiArg = {
  clientId?: string
}
export type PostEmailByClientIdJunkListApiResponse = unknown
export type PostEmailByClientIdJunkListApiArg = {
  /** Client id */
  clientId?: string
  /** Query info */
  junkEmailQueryModel: JunkEmailQueryModel
}
export type GetEmailByClientIdJunkAndMessageIdApiResponse = unknown
export type GetEmailByClientIdJunkAndMessageIdApiArg = {
  /** Client id */
  clientId?: string
  /** Query info */
  messageId: string
}
export type PutEmailByClientIdJunkApiResponse = unknown
export type PutEmailByClientIdJunkApiArg = {
  /** Client id */
  clientId?: string
  /** Model containing message ids of those to be moved */
  moveJunkModel: MoveJunkModel
}
export type GetClientByClientIdAvailablecasesApiResponse = unknown
export type GetClientByClientIdAvailablecasesApiArg = {
  /** Client id */
  clientId?: string
}
export type PutCasesByCaseIdMessagesApiResponse = unknown
export type PutCasesByCaseIdMessagesApiArg = {
  /** Caseid <remarks>MoetesakId</remarks> */
  caseId: string
  /** Model containing message ids<remarks>Innboksmeldingid</remarks> */
  putCaseConnectionModel: PutCaseConnectionModel
}
export type GetFrequentrecipientsApiResponse =
  /** status 200 OK */ FrequentRecipientModel[]
export type GetFrequentrecipientsApiArg = {
  /** Client id <remarks>ForvaltningsklientId</remarks> */
  clientId?: string
  /** type = 0 for emails, type = 1 for sms */
  type?: number
}
export type GetConfigurationsByClientIdSignatureApiResponse =
  /** status 200 OK */ SignatureModel
export type GetConfigurationsByClientIdSignatureApiArg = {
  clientId?: string
}
export type PutConfigurationsByClientIdSignatureApiResponse = unknown
export type PutConfigurationsByClientIdSignatureApiArg = {
  clientId?: string
  signatureUpsertModel: SignatureUpsertModel
}
export type PostSmsMessagesListApiResponse =
  /** status 200 OK */ SmsMessageQueryResultRead
export type PostSmsMessagesListApiArg = {
  /** Query info */
  smsMessageQueryModel: SmsMessageQueryModel
}
export type GetSmsMessagesByMessageIdApiResponse =
  /** status 200 OK */ SmsDetailedModelRead
export type GetSmsMessagesByMessageIdApiArg = {
  /** Id of message */
  messageId: string
}
export type PatchSmsMessagesByMessageIdApiResponse = unknown
export type PatchSmsMessagesByMessageIdApiArg = {
  /** SMS inbox message id */
  messageId: string
  /** Patch model */
  body: Operation[]
}
export type DeleteSmsMessagesByMessageIdApiResponse = unknown
export type DeleteSmsMessagesByMessageIdApiArg = {
  /** Message id */
  messageId: string
}
export type PutSmsMessagesByMessageIdLabelsApiResponse = unknown
export type PutSmsMessagesByMessageIdLabelsApiArg = {
  messageId: string
  labelIdsModel: LabelIdsModel
}
export type PatchSmsMessagesApiResponse = unknown
export type PatchSmsMessagesApiArg = {
  /** Patch model */
  messagesPatchModel: MessagesPatchModel
}
export type PostSmsMessagesApiResponse = /** status 200 OK */ string
export type PostSmsMessagesApiArg = {
  newSmsMessageRequestModel: NewSmsMessageRequestModel
}
export type DeleteSmsMessagesApiResponse =
  /** status 200 OK */ DeleteMessagesResponseModel
export type DeleteSmsMessagesApiArg = {
  deleteMessagesRequestModel: DeleteMessagesRequestModel
}
export type PostSmsMessagesByMessageIdSendApiResponse =
  /** status 200 OK */ string
export type PostSmsMessagesByMessageIdSendApiArg = {
  messageId: string
}
export type GetSmsMessagesByMessageIdRecipientsApiResponse =
  /** status 200 OK */ RecipientModelRead[]
export type GetSmsMessagesByMessageIdRecipientsApiArg = {
  messageId: string
}
export type PatchSmsMessagesByMessageIdRecipientsApiResponse = unknown
export type PatchSmsMessagesByMessageIdRecipientsApiArg = {
  messageId: string
  body: Operation[]
}
export type GetSmsMessagesByMessageIdReceiptApiResponse = unknown
export type GetSmsMessagesByMessageIdReceiptApiArg = {
  messageId: string
}
export type GetSmsSettingsByClientIdApiResponse =
  /** status 200 OK */ SmsSettingsModel
export type GetSmsSettingsByClientIdApiArg = {
  clientId?: string
}
export type GetSmsStatusByClientIdApiResponse =
  /** status 200 OK */ SmsStatusModel
export type GetSmsStatusByClientIdApiArg = {
  clientId?: string
}
export type GetEmailByClientIdJunkCountApiResponse =
  /** status 200 OK */ JunkEmailCountModel
export type GetEmailByClientIdJunkCountApiArg = {
  /** Client id */
  clientId?: string
}
export type GetConfigurationsByClientIdAutoreplyApiResponse =
  /** status 200 OK */ AutoReplyModel
export type GetConfigurationsByClientIdAutoreplyApiArg = {
  clientId?: string
}
export type PutConfigurationsByClientIdAutoreplyApiResponse = unknown
export type PutConfigurationsByClientIdAutoreplyApiArg = {
  clientId?: string
  autoReplyUpdateModel: AutoReplyUpdateModel
}
export type InboxConfigurationModel = {
  emailProvider?: EmailProvider
  /** Email address that is configured. */
  email?: string | null
  /** True if email is setup by BBL */
  isTenantConfigured?: boolean
  /** True if email configuration is completed through 3rd party provider. */
  isConfigured?: boolean
  configVersion?: InboxVersion
  /** False if connection to inbox provider is lost due to i.e. password change. Need to initate a new auth if this is the case. */
  isAuthenticated?: boolean
  /** The date of latest manual synchronization. Set initially in inbox2-sync, or at a later stage during manual synchronization */
  syncDate?: string | null
  /** For Office 365 - related to bug where user cannot send mail with attachments size over 3MB. Need to create upload session and draft
    of email for sending mail with larger attachment. This value will define if user has given scope. Should display warning/info in
    frontend for user if false, and provide opportunity to re-enter credentials to obtain given scope.
                
    Note: if this is false, it will only prevent a user from sending email with attachments larger than 3MB. Sending/receiving email will otherwise work normally. */
  hasReadWriteScope?: boolean
  /** Client Id */
  clientId?: string | null
}
export type InboxConfigurationModelRead = {
  emailProvider?: EmailProvider
  /** Email address that is configured. */
  email?: string | null
  /** True if email is setup by BBL */
  isTenantConfigured?: boolean
  /** True if email configuration is completed through 3rd party provider. */
  isConfigured?: boolean
  configVersion?: InboxVersion
  /** False if connection to inbox provider is lost due to i.e. password change. Need to initate a new auth if this is the case. */
  isAuthenticated?: boolean
  valid?: boolean
  /** The date of latest manual synchronization. Set initially in inbox2-sync, or at a later stage during manual synchronization */
  syncDate?: string | null
  /** For Office 365 - related to bug where user cannot send mail with attachments size over 3MB. Need to create upload session and draft
    of email for sending mail with larger attachment. This value will define if user has given scope. Should display warning/info in
    frontend for user if false, and provide opportunity to re-enter credentials to obtain given scope.
                
    Note: if this is false, it will only prevent a user from sending email with attachments larger than 3MB. Sending/receiving email will otherwise work normally. */
  hasReadWriteScope?: boolean
  /** Client Id */
  clientId?: string | null
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type BblErrorModel = {
  /** What went wrong */
  message?: string | null
  /** Stacktrace */
  stackTrace?: string | null
}
export type ExternalInboxAuthModel = {
  emailProvider?: EmailProvider
  /** The email to be configured */
  email?: string | null
  /** Return url to return to after auth success */
  returnUrl?: string | null
}
export type GmailSmtpConfigModel = {
  /** The email to be configured */
  email?: string | null
  /** App password generated in Gmail-account */
  appPassword?: string | null
  /** Date to sync email from. Can be left empty if existing Gmail config with same email exists. */
  syncFromDate?: string | null
}
export type ExternalInboxConfigurationModel = {
  emailProvider?: EmailProvider
  email?: string | null
  /** Specifies start date for synchronization. All emails received from this date will be synchronized. */
  syncFromDate?: string | null
}
export type SynchronizeInboxModel = {
  syncFromDate?: string
  emailProvider?: EmailProvider
}
export type RecipientModel = {
  /** Id of recipient connection in db. Use this if removing recpients via patch */
  id?: string | null
  name?: string | null
  email?: string | null
  nameregisterId?: string | null
  recipientType?: RecipientType
  phonenumber?: string | null
  /** Id of message for the recipient */
  messageId?: string | null
  /** True if the given message has been sent */
  isSent?: boolean
  /** If recipient is a contact */
  isExistingContact?: boolean
}
export type RecipientModelRead = {
  /** Id of recipient connection in db. Use this if removing recpients via patch */
  id?: string | null
  name?: string | null
  email?: string | null
  nameregisterId?: string | null
  recipientType?: RecipientType
  phonenumber?: string | null
  /** Id of message for the recipient */
  messageId?: string | null
  /** True if the given message has been sent */
  isSent?: boolean
  /** Determining the validity of the email adress */
  validEmail?: boolean
  /** Determining the validity of the phonenumber */
  validPhonenumber?: boolean
  /** If recipient is a contact */
  isExistingContact?: boolean
}
export type LabelModel = {
  id?: string | null
  path?: string | null
  colorCodeId?: number
}
export type EmailListModel = {
  /** Message id */
  id?: string | null
  title?: string | null
  sentDate?: string | null
  isRead?: boolean
  hasAttachments?: boolean
  createdDate?: string
  /** Email is from */
  fromEmail?: string | null
  /** Name of sender if present in HF */
  fromName?: string | null
  /** True if given email has labels connected */
  hasLabels?: boolean
  /** Recipients of email. Only included when query model is specified with status EmailMessageQueryStatus.Sent. Null otherwise */
  recipients?: RecipientModel[] | null
  /** Case Id (møtesakId) if the message is connected to a case. Otherwise Null. */
  caseId?: string | null
  state?: MessageState
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** If message has been forwarded */
  isForwarded?: boolean
  /** If message has been replied on (reply or reply-all) */
  isRepliedOn?: boolean
  /** If message has been replied on (reply or reply-all) */
  sendingFailure?: boolean
  /** A list of labels added to the e-mail. */
  labels?: LabelModel[] | null
  /** If message has ExternalId with ExternalData (meeting notice) */
  hasExternalData?: boolean
  /** Short single line preview of the message body in plain text (max 100 characters). Null if the message has no text */
  preview?: string | null
}
export type EmailListModelRead = {
  /** Message id */
  id?: string | null
  title?: string | null
  sentDate?: string | null
  isRead?: boolean
  hasAttachments?: boolean
  createdDate?: string
  /** Email is from */
  fromEmail?: string | null
  /** Name of sender if present in HF */
  fromName?: string | null
  /** True if given email has labels connected */
  hasLabels?: boolean
  /** Recipients of email. Only included when query model is specified with status EmailMessageQueryStatus.Sent. Null otherwise */
  recipients?: RecipientModelRead[] | null
  /** Case Id (møtesakId) if the message is connected to a case. Otherwise Null. */
  caseId?: string | null
  state?: MessageState
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** If message has been forwarded */
  isForwarded?: boolean
  /** If message has been replied on (reply or reply-all) */
  isRepliedOn?: boolean
  /** If message has been replied on (reply or reply-all) */
  sendingFailure?: boolean
  /** A list of labels added to the e-mail. */
  labels?: LabelModel[] | null
  /** If message has ExternalId with ExternalData (meeting notice) */
  hasExternalData?: boolean
  /** Short single line preview of the message body in plain text (max 100 characters). Null if the message has no text */
  preview?: string | null
}
export type EmailMessageQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: EmailListModel[] | null
}
export type EmailMessageQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: EmailListModelRead[] | null
}
export type PeriodQueryModel = {
  /** From date */
  from?: string | null
  /** To date */
  to?: string | null
}
export type DatesQueryModel = {
  received?: PeriodQueryModel
  sent?: PeriodQueryModel
  deleted?: PeriodQueryModel
  processed?: PeriodQueryModel
}
export type EmailMessageQueryModel = {
  /** The client id (forvaltningsklient-id) */
  clientId?: string | null
  /** Query text */
  searchText?: string | null
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  sortColumn?: SortColumn
  sortOrder?: SortOrder
  /** Specify to filter by given labelid
    <remarks>Filtrer på etikettid</remarks> */
  labelId?: string | null
  queryStatus?: EmailMessageQueryStatus
  onlyUnread?: boolean
  dates?: DatesQueryModel
}
export type EmailStatisticsModel = {
  /** Number of unread emails */
  unreadCount?: number
  /** Number of failed messages (sending) */
  sendingFailureCount?: number
}
export type PersonModel = {
  name?: string | null
  nameId?: string | null
  email?: string | null
  phonenumber?: string | null
}
export type AttachmentMetadataModel = {
  attachmentId?: string | null
  filename?: string | null
  contentType?: string | null
  length?: number
  url?: string | null
}
export type MessageRelation = {
  messageId?: string | null
  relation?: string | null
  when?: string | null
  nameId?: string | null
  name?: string | null
  state?: MessageState
}
export type ExternalEventDataModel = {
  eventStart?: string | null
  eventEnd?: string | null
  eventLocation?: string | null
}
export type EmailModel = {
  /** Id of message */
  id?: string | null
  /** Client id
    <remarks>ForvaltningsklientId</remarks> */
  clientId?: string | null
  /** Dunno if this is needed... */
  providerMessageId?: string | null
  /** If message is a reply to  another messages */
  replyToMessageId?: string | null
  type?: MessageType
  /** Date created */
  createdDate?: string
  /** Date when message either created OR sent if incoming messages */
  time?: string
  /** Title of email */
  title?: string | null
  /** If connected to a case, id of that case.
    <remarks>Møtesakid</remarks> */
  caseId?: string | null
  /** Case title
    <remarks>Møtesak tittel</remarks> */
  caseTitle?: string | null
  /** Message content in text format */
  content?: string | null
  /** Content in HTML */
  contentHtml?: string | null
  /** Date when message has been read */
  readDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** Date when message was sent. For messages where InboxMessageStatus = 1 (Sent) */
  sentDate?: string | null
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  deletedBy?: PersonModel
  processedBy?: PersonModel
  from?: PersonModel
  /** List of message recipients. TODO: remove when frontend uses GET Recipients endpoint */
  recipients?: RecipientModel[] | null
  /** List of attachments */
  attachments?: AttachmentMetadataModel[] | null
  /** Message labels */
  labels?: LabelModel[] | null
  state?: MessageState
  status?: InboxMessageStatus
  /** If sending in process, text is "sending", sent with time sent of an errormessage if failure sending */
  sendingStatusText?: string | null
  /** If this message has been forwarded, if so: list of all forwards, replies and reply-all messages (with id of messages based on this) */
  forwardsOrReplies?: MessageRelation[] | null
  parentRelation?: MessageRelation
  externalData?: ExternalEventDataModel
}
export type EmailModelRead = {
  /** Id of message */
  id?: string | null
  /** Client id
    <remarks>ForvaltningsklientId</remarks> */
  clientId?: string | null
  /** Dunno if this is needed... */
  providerMessageId?: string | null
  /** If message is a reply to  another messages */
  replyToMessageId?: string | null
  type?: MessageType
  /** Date created */
  createdDate?: string
  /** Date when message either created OR sent if incoming messages */
  time?: string
  /** For incoming messages - InboxMessageStatus = 0 Recieved */
  receivedDate?: string | null
  /** Title of email */
  title?: string | null
  /** If connected to a case, id of that case.
    <remarks>Møtesakid</remarks> */
  caseId?: string | null
  /** Case title
    <remarks>Møtesak tittel</remarks> */
  caseTitle?: string | null
  /** Message content in text format */
  content?: string | null
  /** Content in HTML */
  contentHtml?: string | null
  /** Date when message has been read */
  readDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** Date when message was sent. For messages where InboxMessageStatus = 1 (Sent) */
  sentDate?: string | null
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  deletedBy?: PersonModel
  processedBy?: PersonModel
  from?: PersonModel
  /** List of message recipients. TODO: remove when frontend uses GET Recipients endpoint */
  recipients?: RecipientModelRead[] | null
  /** List of attachments */
  attachments?: AttachmentMetadataModel[] | null
  /** True if message has attachments */
  hasAttachments?: boolean
  /** Message labels */
  labels?: LabelModel[] | null
  state?: MessageState
  status?: InboxMessageStatus
  /** If sending in process, text is "sending", sent with time sent of an errormessage if failure sending */
  sendingStatusText?: string | null
  /** If this message has been forwarded, if so: list of all forwards, replies and reply-all messages (with id of messages based on this) */
  forwardsOrReplies?: MessageRelation[] | null
  parentRelation?: MessageRelation
  externalData?: ExternalEventDataModel
}
export type Operation = {
  operationType?: OperationType
  path?: string | null
  op?: string | null
  from?: string | null
  value?: any | null
}
export type LabelIdsModel = {
  labelIds?: string[] | null
}
export type PatchMessagesResponseModel = {
  /** Ids for messages that were changed */
  patchedMessageIds?: string[] | null
  /** Ids for messages that were not changed. Useful if some messages could not be moved to the deleted folder. */
  notPatchedMessageIds?: string[] | null
}
export type IContractResolver = object
export type SingleMessagePatchModelJsonPatchDocument = {
  contractResolver?: IContractResolver
}
export type SingleMessagePatchModelOperation = {
  operationType?: OperationType
  path?: string | null
  op?: string | null
  from?: string | null
  value?: any | null
}
export type SingleMessagePatchModelJsonPatchDocumentRead = {
  operations?: SingleMessagePatchModelOperation[] | null
  contractResolver?: IContractResolver
}
export type MessagePatchModel = {
  /** Email inbox message Id */
  id?: string | null
  patchModel?: SingleMessagePatchModelJsonPatchDocument
}
export type MessagePatchModelRead = {
  /** Email inbox message Id */
  id?: string | null
  patchModel?: SingleMessagePatchModelJsonPatchDocumentRead
}
export type MessagesPatchModel = {
  model?: MessagePatchModel[] | null
}
export type MessagesPatchModelRead = {
  model?: MessagePatchModelRead[] | null
}
export type NewEmailMessageRequestModel = {
  /** Client id
    <remarks>ForvaltningsklientId</remarks> */
  clientId?: string | null
  /** Title of email */
  title?: string | null
  /** Content in HTML */
  contentHtml?: string | null
}
export type DeleteMessagesResponseModel = {
  /** Ids for messages that were deleted */
  deletedMessageIds?: string[] | null
  /** Ids for messages that were not deleted. Used when some of the messages could be deleted (if none of the messages could be deleted, the request is not successful). */
  notDeletedMessageIds?: string[] | null
  /** Ids for messages that were not found. */
  notFoundMessageIds?: string[] | null
}
export type DeleteMessagesRequestModel = {
  /** Ids for messages to delete */
  messageIds?: string[] | null
}
export type EmailMessageReplyRequestModel = {
  toAll?: boolean
}
export type ReadStatusSummary = {
  messageId?: string | null
  readCount?: number
}
export type ReadStatusUserDetails = {
  nameId?: string | null
  userFullName?: string | null
}
export type ReadStatusDetails = {
  usersRead?: ReadStatusUserDetails[] | null
  usersUnread?: ReadStatusUserDetails[] | null
}
export type LabelsModel = {
  labels?: LabelModel[] | null
}
export type JunkEmailQueryModel = {
  searchText?: string | null
}
export type MoveJunkModel = {
  /** Ids of junk email messages to be moved to inbox */
  messageIds?: string[] | null
  destination?: JunkMailDestination
}
export type PutCaseConnectionModel = {
  messageIds?: string[] | null
}
export type FrequentRecipientModel = {
  address?: string | null
  nameregisterId?: string | null
  name?: string | null
  email?: string | null
  phonenumber?: string | null
  count?: number
}
export type StandardSignatureModel = {
  /** Full name of current user, to be displayed below "Vennlig hilsen". */
  userFullName?: string | null
  /** Board member function name for the current user, to be displayed below UserFullName. */
  userBoardMemberFunction?: string | null
  /** Name of the client, as an alternative to UserBoardFunction. */
  clientName?: string | null
}
export type SignatureModel = {
  standardLines?: StandardSignatureModel
  /** Additional lines to the email signature that can be customized by the client's board members.
                
    Example:
    <p>
    Mobil: 999 99 999
    
    E-post: mittstyre@borettslaget.no
    </p> */
  additionalLines?: string | null
  /** NameId (navneregisterId) for the user who last made changes. */
  lastChangedByNameId?: string | null
  /** When changes were last made. */
  lastChanged?: string | null
}
export type SignatureUpsertModel = {
  /** Additional lines to the email signature that can be customized by the client's board members.
                
    Example:
    <p>
    Mobil: 999 99 999
    
    E-post: mittstyre@borettslaget.no
    </p> */
  additionalLines?: string | null
}
export type SmsListModel = {
  /** Message id */
  id?: string | null
  /** Date when message has been sent */
  sentDate?: string | null
  isRead?: boolean
  createdDate?: string
  /** True if given email has labels connected */
  hasLabels?: boolean
  /** SMS content */
  content?: string | null
  /** SMS is from */
  fromPhonenumber?: string | null
  /** Name of sender if present in HF */
  fromName?: string | null
  /** Recipients of sms. Only included when query model is specified with status EmailMessageQueryStatus.Sent. Null otherwise */
  recipients?: RecipientModel[] | null
  state?: MessageState
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** Case Id (møtesakId) if the message is connected to a case. Otherwise Null. */
  caseId?: string | null
  /** List of labels added to the SMS */
  labels?: LabelModel[] | null
}
export type SmsListModelRead = {
  /** Message id */
  id?: string | null
  /** Date when message has been sent */
  sentDate?: string | null
  isRead?: boolean
  createdDate?: string
  /** True if given email has labels connected */
  hasLabels?: boolean
  /** SMS content */
  content?: string | null
  /** SMS is from */
  fromPhonenumber?: string | null
  /** Name of sender if present in HF */
  fromName?: string | null
  /** Recipients of sms. Only included when query model is specified with status EmailMessageQueryStatus.Sent. Null otherwise */
  recipients?: RecipientModelRead[] | null
  state?: MessageState
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** Case Id (møtesakId) if the message is connected to a case. Otherwise Null. */
  caseId?: string | null
  /** List of labels added to the SMS */
  labels?: LabelModel[] | null
}
export type SmsMessageQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: SmsListModel[] | null
}
export type SmsMessageQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: SmsListModelRead[] | null
}
export type SmsMessageQueryModel = {
  /** The client id (forvaltningsklient-id) */
  clientId?: string | null
  /** Query text */
  searchText?: string | null
  /** Number of records to return, default is 10. If set to -1 for both Take and Skip, paging is not done */
  take?: number
  /** Number of records to skip on top. If set to -1 for both Take and Skip, paging is not done */
  skip?: number
  sortColumn?: SortColumn
  sortOrder?: SortOrder
  /** Specify to filter by given labelid
    <remarks>Filtrer på etikettid</remarks> */
  labelId?: string | null
  queryStatus?: SmsMessageQueryStatus
  /** Query SMS with sent date after specified date */
  from?: string | null
  /** Query SMS with sent date up until specified date */
  to?: string | null
  dates?: DatesQueryModel
}
export type SmsDetailedModel = {
  /** Id of message */
  id?: string | null
  /** Client id
    <remarks>ForvaltningsklientId</remarks> */
  clientId?: string | null
  /** If message is a reply to  another messages */
  replyToMessageId?: string | null
  type?: MessageType
  /** Date created */
  createdDate?: string
  /** If connected to a case, id of that case.
    <remarks>Møtesakid</remarks> */
  caseId?: string | null
  /** Case title
    <remarks>Møtesak tittel</remarks> */
  caseTitle?: string | null
  /** Message content in text format */
  content?: string | null
  /** Date when message has been read */
  readDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** Date when message was sent. */
  sentDate?: string | null
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  deletedBy?: PersonModel
  processedBy?: PersonModel
  /** Message labels */
  labels?: LabelModel[] | null
  state?: MessageState
  status?: InboxMessageStatus
  /** If sending in process, text is "sending", sent with time sent of an errormessage if failure sending */
  sendingStatusText?: string | null
  /** SMS Recipients */
  recipients?: RecipientModel[] | null
  parentRelation?: MessageRelation
  from?: PersonModel
}
export type SmsDetailedModelRead = {
  /** Id of message */
  id?: string | null
  /** Client id
    <remarks>ForvaltningsklientId</remarks> */
  clientId?: string | null
  /** If message is a reply to  another messages */
  replyToMessageId?: string | null
  type?: MessageType
  /** Date created */
  createdDate?: string
  /** If connected to a case, id of that case.
    <remarks>Møtesakid</remarks> */
  caseId?: string | null
  /** Case title
    <remarks>Møtesak tittel</remarks> */
  caseTitle?: string | null
  /** Message content in text format */
  content?: string | null
  /** Date when message has been read */
  readDate?: string | null
  /** Date of deletion */
  deletedDate?: string | null
  /** Date when message was sent. */
  sentDate?: string | null
  /** Date when email was processed
    <remarks>Behandlet dato</remarks> */
  processedDate?: string | null
  deletedBy?: PersonModel
  processedBy?: PersonModel
  /** Message labels */
  labels?: LabelModel[] | null
  state?: MessageState
  status?: InboxMessageStatus
  /** If sending in process, text is "sending", sent with time sent of an errormessage if failure sending */
  sendingStatusText?: string | null
  /** SMS Recipients */
  recipients?: RecipientModelRead[] | null
  parentRelation?: MessageRelation
  from?: PersonModel
}
export type NewSmsMessageRequestModel = {
  /** Client id
    <remarks>ForvaltningsklientId</remarks> */
  clientId?: string | null
  /** MessagingSms content */
  content?: string | null
}
export type SmsSettingsModel = {
  unitPrice?: number | null
  warningLimit?: number | null
  maxLimit?: number | null
  maxLengthSms?: number
  smsHasBeenUsed?: boolean
  isSmsAvailable?: boolean
}
export type SmsStatusModel = {
  numberOfSmsNotInvoiced?: number
}
export type JunkEmailCountModel = {
  /** Total messages in the junk folder. Null when the provider can't count junk (Gmail) or e-mail is not set up */
  totalCount?: number | null
}
export type AutoReplyModel = {
  /** False for Gmail, for inboxes that are not set up, and for Office365 clients that lack the MailboxSettings.ReadWrite permission.
    Delegated Office365 clients get the permission by re-authenticating, tenant clients need admin consent. */
  isAvailable?: boolean
  status?: AutoReplyStatus
  /** Reply text (html) */
  message?: string | null
  /** Start of the period when Status is Scheduled (UTC) */
  scheduledStart?: string | null
  /** End of the period when Status is Scheduled (UTC) */
  scheduledEnd?: string | null
}
export type AutoReplyUpdateModel = {
  status?: AutoReplyStatus
  /** Reply text (html). Required unless Status is Disabled. When omitted on Disabled, the stored text is kept. */
  message?: string | null
  /** Required when Status is Scheduled */
  scheduledStart?: string | null
  /** Required when Status is Scheduled, must be after ScheduledStart */
  scheduledEnd?: string | null
}
export enum EmailProvider {
  $0 = 0,
  $1 = 1,
}
export enum InboxVersion {
  $0 = 0,
  $1 = 1,
}
export enum RecipientType {
  $0 = 0,
  $1 = 1,
  $2 = 2,
}
export enum MessageState {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
}
export enum SortColumn {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
}
export enum SortOrder {
  $0 = 0,
  $1 = 1,
}
export enum EmailMessageQueryStatus {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
}
export enum MessageType {
  $0 = 0,
  $1 = 1,
}
export enum InboxMessageStatus {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
}
export enum OperationType {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5,
  $6 = 6,
}
export enum JunkMailDestination {
  $0 = 0,
  $1 = 1,
}
export enum SmsMessageQueryStatus {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $5 = 5,
}
export enum AutoReplyStatus {
  $0 = 0,
  $1 = 1,
  $2 = 2,
}
export const {
  useGetConfigurationsByClientIdQuery,
  usePostConfigurationsByClientIdMutation,
  useDeleteConfigurationsByClientIdMutation,
  usePostConfigurationsGmailByClientIdMutation,
  usePostConfigurationsByClientIdConfirmationMutation,
  usePostConfigurationsByClientIdSyncMutation,
  useGetEmailMessagesByMessageIdAttachmentsAndAttachmentIdQuery,
  useDeleteEmailMessagesByMessageIdAttachmentsAndAttachmentIdMutation,
  usePostEmailMessagesByMessageIdAttachmentsMutation,
  usePostEmailMessagesListQuery,
  useGetEmailMessagesStatisticsQuery,
  useGetEmailMessagesByMessageIdQuery,
  usePatchEmailMessagesByMessageIdMutation,
  useDeleteEmailMessagesByMessageIdMutation,
  usePutEmailMessagesByMessageIdLabelsMutation,
  useGetEmailMessagesByMessageIdLabelsQuery,
  usePatchEmailMessagesMutation,
  usePostEmailMessagesMutation,
  useDeleteEmailMessagesMutation,
  usePostEmailMessagesByMessageIdReplyMutation,
  usePostEmailMessagesByMessageIdForwardMutation,
  usePostEmailMessagesByMessageIdSendMutation,
  usePostEmailMessagesByMessageIdSendDirectMutation,
  useGetEmailMessagesByMessageIdRecipientsQuery,
  usePatchEmailMessagesByMessageIdRecipientsMutation,
  useGetEmailMessagesByMessageIdReceiptQuery,
  usePutEmailMessagesByMessageIdIsreadMutation,
  useGetEmailMessagesByMessageIdReadstatusSummaryQuery,
  useGetEmailMessagesByMessageIdReadstatusQuery,
  useGetLabelsQuery,
  usePostEmailByClientIdJunkListQuery,
  useGetEmailByClientIdJunkAndMessageIdQuery,
  usePutEmailByClientIdJunkMutation,
  useGetClientByClientIdAvailablecasesQuery,
  usePutCasesByCaseIdMessagesMutation,
  useGetFrequentrecipientsQuery,
  useGetConfigurationsByClientIdSignatureQuery,
  usePutConfigurationsByClientIdSignatureMutation,
  usePostSmsMessagesListQuery,
  useGetSmsMessagesByMessageIdQuery,
  usePatchSmsMessagesByMessageIdMutation,
  useDeleteSmsMessagesByMessageIdMutation,
  usePutSmsMessagesByMessageIdLabelsMutation,
  usePatchSmsMessagesMutation,
  usePostSmsMessagesMutation,
  useDeleteSmsMessagesMutation,
  usePostSmsMessagesByMessageIdSendMutation,
  useGetSmsMessagesByMessageIdRecipientsQuery,
  usePatchSmsMessagesByMessageIdRecipientsMutation,
  useGetSmsMessagesByMessageIdReceiptQuery,
  useGetSmsSettingsByClientIdQuery,
  useGetSmsStatusByClientIdQuery,
  useGetEmailByClientIdJunkCountQuery,
  useGetConfigurationsByClientIdAutoreplyQuery,
  usePutConfigurationsByClientIdAutoreplyMutation,
} = injectedRtkApi
